/**
 * `resolveEntryArray` is used to remove extraneous object nesting from an array of entries.
 * This is typically used when handling multiple documents returned from a query on
 * a repeatable content type.
 *
 * @param {object|object[]} data An image or array of images
 *
 */

const parseImageData = image => {
  // Get image attributes
  const { uid, url, width, height, title, focalPoint, hasFocalPoint } =
    image || {};

  // Abort if no url
  if (!url) {
    return null;
  }

  return {
    uid,
    url,
    width,
    height,
    alt: title,
    fpx: hasFocalPoint ? focalPoint[0] : null,
    fpy: hasFocalPoint ? focalPoint[1] : null,
  };
};

const resolveImage = data => {
  if (!data) {
    return null;
  }

  const isArray = Array.isArray(data);
  return isArray ? data.map(parseImageData) : parseImageData(data);
};

export default resolveImage;
